import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import MenuGroup from "aldoo-ra/MenuGroup"
import PlatformsAvailable from "../PlatformsAvailable"
import Value from "aldoo-ra/Value"

/**
 * Helper function that renders a platform button
 * @param {*} platform
 * @returns
 */
const renderPlatformButton = (platform) => {
  return (
    <a
      key={platform._id}
      href={platform.link && platform.link[0].url}
      target="_blank"
      rel="noreferrer"
      className="w-[190px] h-[55px] flex items-center gap-2 p-0 hover:opacity-90 transition-opacity"
    >
      <img
        src={platform.image}
        alt={platform.name}
        className="w-full h-full object-cover"
      />
    </a>
  )
}

const TTHeroBanner = () => {
  const [platform, setPlatform] = Value("detected_platform")

  return (
    <div
      className="relative w-full flex justify-center items-center mx-auto"
      style={{ zIndex: 100 }}
    >
      <CMSRender
        contentType="T&T Header Banner"
        renderItem={(data, id) => {
          return (
            <div
              key={id}
              className="w-full max-w-w2_xl flex flex-col lg:flex-row justify-center items-center lg:justify-between lg:gap-10 pt-10 md:pt-[60px] lg:pt-0 px-4 md:px-px1_l xl:px-px1_xl lg:pb-7"
            >
              {/* Left Section */}
              <div className="w-full lg:w-[45%] flex flex-col items-center lg:items-start text-center lg:text-left gap-5 md:gap-[30px] lg:gap-4">
                {/* TT Logo */}
                <div className="w-[110px] h-[110px] flex items-center justify-center rounded-[24px] overflow-hidden scale-100">
                  <img
                    src={data.app_icon}
                    alt="App Icon"
                    className="w-[110px] h-[110px]"
                    imageRendering="crisp-edges"
                  />
                </div>

                {/* Title */}
                <Typography variant="h1" className="text-text leading-none">
                  {data.title}
                </Typography>

                <Typography variant="body1" className="my-0">
                  {data.subtitle}
                </Typography>

                {/* Store Buttons - lg & xl screens */}
                <div className="hidden md:flex items-center w-full gap-2 text-text justify-center lg:justify-start">
                  {data.store_buttons.map(renderPlatformButton)}
                </div>

                {/* Platform-dependant Download btn - mobile screens */}
                <div className="block md:hidden">
                  <MenuGroup
                    name="tt_download"
                    renderAs="hlist"
                    styleOverrides={{
                      menu_item: "my-0",
                    }}
                    itemsAsLinks={false}
                    menuItemRender={(item) => {
                      const url =
                        (item?.link[0]?.parameters &&
                          item?.link[0]?.parameters[platform]) ||
                        item?.link[0]?.url

                      return (
                        <Button variant="primary_tt_l">
                          <a href={url} target="_blank" rel="noreferrer">
                            {item?.label}
                          </a>
                        </Button>
                      )
                    }}
                  />
                </div>

                {/* Platforms Available - hidden for now */}
                {/* <PlatformsAvailable data={data} /> */}

                {/* Rating */}
                <div className="flex flex-col md:flex-row items-center md:gap-[10px]">
                  <img
                    src={data.rating_image}
                    alt="Rating"
                    className="w-[80px] h-[14px]"
                  />

                  <Typography variant="body1_dim" className="mt-2 mb-0 md:my-0">
                    {data.rating_text}
                  </Typography>
                </div>
              </div>

              {/* Right Section */}
              <div className="w-full lg:w-[65%] max-w-[570px] md:max-w-[620px] xl:max-w-[670px] aspect-709/513 lg:pt-[60px] xl:pt-10">
                <img
                  src={data.image}
                  alt="User experience"
                  className="w-full h-auto"
                />
              </div>
            </div>
          )
        }}
      />
    </div>
  )
}

export default TTHeroBanner
